import { EmailService } from './email.service';
import { SmsService } from './sms.service';

export { EmailService } from './email.service';
export { SmsService } from './sms.service';

export const services = [EmailService, SmsService];
